module.exports = __webpack_public_path__ + "static/media/scratch.bb543cf3.png";